import React, { useState } from 'react'
import "./Counter.css";
import CountUp from 'react-countup';
import ScrollTrigger from 'react-scroll-trigger';


const Counter = () => {

    const [counterState, setCounterState] = useState(false)



  return (
    <div>
        <ScrollTrigger onEnter={() => setCounterState(true)} onExit={() => setCounterState(false)}>
      <div className="counter-wrapper">
        <div className="counter">
            <h1 className='count' >
            { counterState &&
            <CountUp
             start={0} 
             end={5}
             duration={2.75}
             >
             </CountUp>
             }+
             </h1>
            <p>Years of Experience</p>
        </div>
        <div className="counter">
            <h1 className='count' >
            { counterState &&
            <CountUp
             start={0} 
             end={200 }
             duration={2.75}
             >
             </CountUp>
             }+
             </h1>
            <p>Products Manufactured</p>
        </div>
        <div className="counter">
            <h1 className='count'>
           { counterState &&
           <CountUp
             start={0} 
             end={95  }
             duration={2.75}
             >
             </CountUp>
             }%
             </h1>
            <p>Satisfied Customers</p>
        </div>
        <div className="counter">
            <h1 className='count'>
            {counterState &&
            <CountUp
             start={0} 
             end={97}
             duration={2.75}
             >
             </CountUp>
             } %
             </h1>
            <p>Happy Clients</p>
        </div>
       
      </div>
      
      </ScrollTrigger>
    </div>
  ) 
}

export default Counter
